interface StatLabelProps {
	label: string;
	value: string | number | Date | null | undefined;
	className?: string;
}

const StatLabel: React.FC<StatLabelProps> = ({ label, value = '-', className }) => {
	return (
		<div className={`flex justify-between items-center ${className || ''}`}>
			<span className="mb-1 text-sm font-medium text-msi-midblue-color-500">{label}:</span>
			<span className="text-right">{value?.toLocaleString()}</span>
		</div>
	);
};

export default StatLabel;
